import { render, staticRenderFns } from "./diguan.vue?vue&type=template&id=63aea10a&scoped=true"
import script from "./diguan.vue?vue&type=script&lang=js"
export * from "./diguan.vue?vue&type=script&lang=js"
import style0 from "./diguan.vue?vue&type=style&index=0&id=63aea10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aea10a",
  null
  
)

export default component.exports